import React, { createContext, useContext, useMemo, ReactNode } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider as MUIThemeProvider, createTheme, Theme } from "@mui/material/styles";

interface ThemeContextType {} 

const ThemeContext = createContext<ThemeContextType>({});

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const theme: Theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: "#fff",
          },
          secondary: {
            main: "#E9EDEC",
          },
          background: {
            default: "#3f6181",
            paper: "#3f6181",
          },
          text: {
            primary: "#000000",
            secondary: "#555",
          },
        },
        typography: {
          fontFamily: "Manrope",
        },
      }),
    []
  );

  return (
    <ThemeContext.Provider value={{}}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => useContext(ThemeContext);
